import ContentWrapper from "@/components/wrappers/ContentWrapper";
import DisplayWrapper from "@/components/wrappers/DisplayWrapper";
import { useParams } from "react-router";
import { useGetFinancialMediation } from "../../../common/api/queries/financialMediation";
import { EntityIdObject } from "../../../common/types";
import { FinancialMediationForm } from "../components/forms/FinancialMediationForm";

const FinancialMediationDetailContainer = () => {
  const { id } = useParams<EntityIdObject>();

  const { data: financialMediation, isError } = useGetFinancialMediation(id);

  return (
    <ContentWrapper>
      <DisplayWrapper itemLoaded={!!financialMediation} isError={isError}>
        <FinancialMediationForm financialMediation={financialMediation} />
      </DisplayWrapper>
    </ContentWrapper>
  );
};

export default FinancialMediationDetailContainer;
